// CP
function preloadImages(array) {
  if (!preloadImages.list) {
      preloadImages.list = [];
  }
  var list = preloadImages.list;
  for (var i = 0; i < array.length; i++) {
      var img = new Image();
      img.onload = function() {
          var index = list.indexOf(this);
          if (index !== -1) {
              // remove image from the array once it's loaded
              // for memory consumption reasons
              list.splice(index, 1);
          }
      }
      list.push(img);
      img.src = array[i];
  }
}

if($('.cp-js-faq').length > 0) {
  $('.cp-faq-question').on('click', function(){
    $('.cp-faq-answer[data-idx=' + $(this).data('idx') +  ']').slideToggle(50);
  });
}

    if($('.js-acf-data').length > 0) {
        window.acf =  $.extend({}, window.acf  , $('.js-acf-data').data('acf') );
    }

    $('a.js-acf-file-url').each(function(){
      this.href = window.acf.page.file;
    });
    
    // Product
    function CpProductColor ( selector ) {
      this.selector = selector;
      this.isBorderCheckbox = false;
      this.init = function() {
        this.$container = $(this.selector);

        if( this.$container.length != 1) {
          return false;
        }
        if($('.cp-product-form-border-checkbox', this.$container).length == 1 ) {
          this.isBorderCheckbox = true;
          this.initBorderCheckbox();
        }
        if($('.cp-product-form-color-select', this.$container).length == 1 ) {
          this.mode = "select";
          this.$optionsContainer = $('.cp-product-form-color-select', this.$container);
          this.initSelectColor();
        }

        if($('.cp-product-form-color-list', this.$container).length == 1 ) {
          this.mode = "list";
          this.$optionsContainer = $('.cp-product-form-color-list', this.$container);
          this.initListColor();
        }      
        return true;  
      }
      this.initBorderCheckbox = function () {
        const $borderCheckbox = $('.cp-product-form-border-checkbox input', this.$container);
        $('.cp-js-product-form-color',this.$container).removeAttr('disabled' );
        $('.cp-product-form-color-wrapper', this.$container).addClass('show');

        $borderCheckbox.on('change',() => {
            $borderCheckbox[0].checked = true;
            // if ($borderCheckbox[0].checked) {
            //   $('.cp-js-product-form-color',this.$container).removeAttr('disabled' );
            //   $('.cp-product-form-color-wrapper', this.$container).addClass('show');
            // } else {
            //  $('.cp-js-product-form-color',this.$container).attr('disabled', 'disabled' );
            //  $('.cp-product-form-color-wrapper', this.$container).removeClass('show');
            // }
        });
      }
      
      this.initSelectColor = function () {
          $('.cp-js-product-form-color',this.$container)
          .on('change', () => {
             const image_url = $('.cp-js-product-form-color option:selected',this.$container).data('image-url'); 
             $('.cp-variant-btn', this.$container ).css('background-image','url(' + image_url + ')');
          });
      }

      this.initListColor = function () {
        if( this.isBorderCheckbox ) {
          const images = [];
          $('.cp-variant-btn', this.$container ).each((index, elm) => {
            images.push($(elm).data('image-url'));
          });
          preloadImages(images);
        }

        $('.cp-variant-btn', this.$container ).css('cursor','pointer').on('click', (e) => {
          $('.cp-js-product-form-color',this.$container)
            .val( $(e.target).data('value'));
          $('.cp-js-product-form-label-info',  this.$container).text ('- ' + $(e.target).data('value') );
          $( e.target )
            .addClass('active')
            .siblings().removeClass('active');
        });
      }

      this.validate = function () {
        // if( this.$container.length != 1) {
        //   return true;
        // }        
         return true;
      }
     
    }
    const cpProductCalculator = new function() {
        this.init = function () {
            this.$container = $('.cp-js-calculator-wrapper');
            this.$borderCheckbox = $('.cp-product-form-border-checkbox input');
            this.isRendering = false;
            if(this.$container.length == 0 ) {
              return false;
            } 
            else {
              let _this = this;
              let generateInterval = setInterval( () => {
                console.log( 'interval run' );
                if ( $( '#calculator .price-marker' ).length > 0 ) {
                  clearInterval( generateInterval );
                  console.log( 'found calc price-marker' );
                  if (this.isRendering == false) {
                    this.isRendering = true;
                    setTimeout( () => {
                       this.generateLayout();
                    });
                 }                
                }
              }, 500);
            }
            
            console.log('cpProductCalculator');

            if ( $('.cp-variant-wrapper').first().find('fieldset[name="Size"]').length > 0 ) {
              $('.cp-variant-wrapper').first().hide();
            }
          
            //$('.cp-variant-wrapper').first().hide();
            $('.cp-variant-wrapper-sep').first().hide();
            //$('.cp-variant-wrapper-sep').eq(1).hide();
            $(".cp-product-section").on('DOMSubtreeModified', "#calculator", () => {
               if (this.isRendering == false) {
                  this.isRendering = true;
                  setTimeout( () => {
                     this.generateLayout();
                  });
               }
            });

        }

        this.generateLayout = function () {
          console.log('generateLayout');
          
          $('.element[data-element]:not(".hide-element"):gt(0)', this.$container).each(function(){
             if($(this).data('element') != 'Add Border'  ) {
               $(this).before('<div class="cp-variant-wrapper-sep"></div>');
             }
          });

          $('.price-marker ', this.$container).before('<div class="cp-variant-wrapper-sep"></div>');
          $('button.add-to-cart', this.$container).wrap('<div class="cp-variant-wrapper cp-variant-wrapper-2"><div class="cp-payment-buttons'
          + ( $('button.add-to-cart', this.$container).hasClass('cp-center') ? ' center': '' )
          + '"></div></div>');
          this.borderCheckboxChange();
          this.borderCheckboxBind();
          this.$container.addClass('show');
        }
        this.borderCheckboxBind = function() {
          this.$borderCheckbox.on('change', () => {
            this.borderCheckboxChange();
          });
        }
        this.borderCheckboxChange = function() {
           if($('.element[data-element="Add Border"] input', this.$container).length == 1 && this.$borderCheckbox.length == 1  ) {
             console.log( 'borderCheckboxChange');
             $('.element[data-element="Add Border"] input', this.$container)[0].checked = this.$borderCheckbox[0].checked;
             $('.element[data-element="Add Border"] input', this.$container).trigger('change');
           }
        }
    }
    const cpProductDimension = new function() {
      this.isInitialized = false;
      this.currentWidthFt = '';
      this.currentWidthIn = '0';
      this.currentWithListIndex = 0;


      
      this.init = function () {
        this.$container = $('#cp-js-product-custom-form .cp-product-dimension-component');
        this.$variant = $('.cp-product-meta  [data-handle="size"] select');

        if(this.$container.length == 0 ) {
          return false;
        }       
       
        this.$widthFt = $('select[name="cp-variant-width-ft"]', this.$container);
        this.$widthIn = $('select[name="cp-variant-width-in"]', this.$container);
        
        this.lengthList =  this.$container.data('cp-length-list');
        this.$lengthFt = $('select[name="cp-variant-length-ft"]', this.$container);
        this.$lengthIn = $('select[name="cp-variant-length-in"]', this.$container);

        this.$property = $('input[name="properties[Dimension]"]', this.$container);
   
        if(this.isInitialized == false) {
          this.firstInit();
          this.isInitialized = true;
        } else {
          this.nextInit();
        }

 
        this.addWidthFtEventListener();
        this.initWidthIn();
        this.addWidthInEventListener();
        
        this.addLengthFtEventListener();
        this.addLengthInEventListener();

        return true;
      }

      this.firstInit = function() {

        this.$mainContainer = $('#MainContent');
        this.widthList =  this.$container.data('cp-width-list');
        this.currentWidthFt  = this.$widthFt.val();
        this.currentWidthIn = '0';

        this.currentWithListIndex  = this.widthList.findIndex((element) => {
          return element['selected'] == true;
        });

        if( this.currentWithListIndex == this.widthList.length - 1   ) {
          this.currentWidthFt = this.widthList[this.widthList.length - 2]['label'];
          this.currentWidthIn = '0';
          this.currentWithListIndex = this.widthList.length - 2;

          setTimeout(() => { 
            this.loadByWidthListIndex( this.currentWithListIndex  );         
          });
        }

        const variantIndex = this.lengthList.indexOf( this.$variant.val());
        if( variantIndex == this.lengthList.length - 1 ){
            const lengthFtVal = this.lengthList[ this.lengthList.length - 2];
            this.$lengthFt.val(lengthFtVal);
            this.$variant.val(lengthFtVal);
            this.$variant.trigger('change');
        }
      }
      this.nextInit = function() {
          setTimeout(() => {
            this.$widthFt.val( this.currentWidthFt );
            this.$widthIn.val( this.currentWidthIn );
          });
      }

      this.lockFormFields = function() {
        this.$widthFt.attr('readonly','readonly');  
        this.$widthIn.attr('readonly','readonly');  
        this.$lengthFt.attr('readonly','readonly');  
        this.$lengthIn.attr('readonly','readonly');  
      }
      this.unlockFormFields = function() {
        this.$widthFt.removeAttr('readonly');  
        this.$widthIn.removeAttr('readonly');  
        this.$lengthFt.removeAttr('readonly');  
        this.$lengthIn.removeAttr('readonly');  
      }

      this.getCurrentWidthListIndex = function ( ) {
        const  width = this.$widthFt.val();
        const index  = this.widthList.findIndex((element) => {
          return element['label'] == width;
        });
        return index;
      }

      this.loadByWidthListIndex = function( index ) {
        if(index == -1  || this.widthList.length - 1 < index  ) {
          return;
        }

        this.$mainContainer.data('cp-product-url', this.widthList[index]['url'] );
        this.$mainContainer.trigger('change_cp_product_url');        
      }

      this.addWidthFtEventListener = function() {
          this.$widthFt.on('change', () => {
              this.lockFormFields();
              this.currentWidthFt  = this.$widthFt.val();
              this.currentWithListIndex  =  this.getCurrentWidthListIndex();
              this.currentWidthIn = '0';
              this.loadByWidthListIndex ( this.currentWithListIndex  );
          });
      }



      this.initWidthIn = function() {
          this.$widthIn.val(this.currentWidthIn);
      }

      this.addWidthInEventListener = function() {
        this.$widthIn.on('change', () => {
            const nextWidthIn = this.$widthIn.val();
            const currentWidthInNumber = parseFloat(this.currentWidthIn);
            const nextWidthInNumber = parseFloat(nextWidthIn);

            this.currentWidthIn = nextWidthIn;
            if( currentWidthInNumber == 0 && nextWidthInNumber > 0 ){

              this.lockFormFields();
              this.currentWithListIndex++;  
              this.loadByWidthListIndex(this.currentWithListIndex );

            } else if ( currentWidthInNumber > 0 && nextWidthInNumber == 0 )  {

              this.lockFormFields();
              this.currentWithListIndex--;
              this.loadByWidthListIndex( this.currentWithListIndex );

            } 
         });
      }

      this.addLengthFtEventListener = function() {

        this.$lengthFt.on('change', () => {

            this.$variant.val( this.$lengthFt.val() );
            this.$variant.trigger('change');
            this.$lengthIn.val('0');
        });
    }  
    
    this.addLengthInEventListener = function() {
      this.$lengthIn.on('change', () => {
          const inch = this.$lengthIn.val();
          const inchNumber = parseFloat(inch);
          let index = this.lengthList.indexOf( this.$lengthFt.val());
    
          if( inchNumber > 0) {
            index++
          }

          this.$variant.val(this.lengthList[index]);
          this.$variant.trigger('change');
      });
    }

    this.updateProperty = function () {
      const property = 
        this.$widthFt.val().replace('x','').trim() + ' ft '+ 
        ( this.$widthIn.val() ? this.$widthIn.val() : 0  ) + ' in x ' +
        this.$lengthFt.val() + ' ft '+ 
        ( this.$lengthIn.val() ? this.$lengthIn.val() : 0  ) + ' in'             
        ; 

        this.$property.val( property );
    }


      this.validate = function () {
      if( this.$container.length == 1) {
        this.updateProperty();
        }  
        
        return true;
      }      
    
    }
    const cpProductDimensionV1 = new function() {
      this.init = function () {
        this.$container = $('#cp-js-product-custom-form  .cp-product-dimension-v1-component');
        if(this.$container.length == 0 ) {
          return;
        }
        
        this.$heightSelect = $('form.product-single__form .variant-input-wrap[data-handle=size] select'); 

        this.$widthFt = $('#cp-js-product-custom-form  .cp-product-dimension-v1-component__width input[type=text]');
        this.$widthIn = $('#cp-js-product-custom-form  .cp-product-dimension-v1-component__width input[type=number]');
        
        this.$heightFt = $('#cp-js-product-custom-form  .cp-product-dimension-v1-component__height input[type=text]');
        this.$heightIn = $('#cp-js-product-custom-form  .cp-product-dimension-v1-component__height input[type=number]');   
        
        this.$property = $('input[name="properties[DimensionV1]"]', this.$container);
        
        
       
        this.updateWidth();
        this.updateHeight();

        this.$heightSelect.on('change', () => {
          this.updateHeight();
        });

        this.$widthIn.on('change', () => {
          this.updateProperty();
        });
        
        this.$heightIn.on('change', () => {
          this.updateProperty();
        });        
      }

      this.updateWidth = function () {
        const widthFt = $('form.product-single__form .cp-product-variant-size').data('cp-size');
        if(!widthFt) {
          widthFt = '0';
        }
        this.$widthFt.val(widthFt.replace('x','').trim());

        this.updateProperty();

      }
      this.updateHeight = function () {
          const heightFt = this.$heightSelect.val();
          this.$heightFt.val(heightFt);
          this.updateProperty();
      }

      this.updateProperty = function () {
          const property = 
            this.$widthFt.val().replace('x','') + ' ft '+ 
            ( this.$widthIn.val() ? this.$widthIn.val() : 0  ) + ' in x ' +
            this.$heightFt.val() + ' ft '+ 
            ( this.$heightIn.val() ? this.$heightIn.val() : 0  ) + ' in'             
            ; 
            this.$property.val( property );
      }
      this.validate = function () {

        return true;
      }
    }

    const cpProductArtwork = new function() {

       this.init = function() {
          this.$container = $('#cp-js-product-custom-form .cp-product-custom-form-artwork-component');
          
          if( this.$container.length != 1) {
            return false;
          }
          
          this.fileInput =  $('.cp-product-form-artwork input[type="file"]', this.$container)[0];   
          this.isAddedFile = false;

          this.initOrientationField();
          this.initInstructionsField();
          this.initArtworkFields();
          return true;
       }

       this.initOrientationField = function() {
          $('.cp-product-form-orientation-horizontal,.cp-product-form-orientation-vertical',this.$container )
          .on('click',function(e){
              $(this).addClass('active').siblings().removeClass('active');
          });
       }
       
       this.initInstructionsField = function() {
        const $btn =  $('.cp-product-form-special-instructions-btn .btn',this.$container );
        $btn.on('click',() => {
            $btn.parent().removeClass('show');
            $('.cp-product-form-special-instructions',this.$container ).addClass('show');
          });
        }

       this.initArtworkFields = function () {
          $(this.fileInput)
          .on('change', () =>  {
            $('.cp-product-form-design-number, .cp-product-form-artwork', this.$container).removeClass('has-error');
            const files = this.fileInput.files;
            const $fileInfo =  $('.cp-product-form-artwork em', this.$container);
            if ( files.length > 0 ) {
              $fileInfo.text( 
                $fileInfo.data('prefix') + files[0].name
              );
              this.isAddedFile = true;            
    
            } else {
              $fileInfo.text('');
              this.isAddedFile = false;
            }
          });
  
        $('.cp-product-form-design-number input, .cp-product-form-artwork-by-email-checkbox input')
        .on('change focus', () => {
          $('.cp-product-form-design-number, .cp-product-form-artwork, .cp-product-form-artwork-by-email-checkbox', this.$container).removeClass('has-error');
        });

        

       }

       this.validate = function () {
            // return true;
            
            if( this.$container.length != 1) {
              return true;
            }

            if(
              this.isAddedFile == false &&
              $('.cp-product-form-design-number input',this.$container ).val().trim().length == 0 &&
              
              $('.cp-product-form-artwork-by-email-checkbox input:checked',this.$container).length == 0
              ) {
                $('.cp-product-form-design-number, .cp-product-form-artwork, .cp-product-form-artwork-by-email-checkbox', this.$container).addClass('has-error');
                return false;
              }
              $('.cp-product-form-design-number, .cp-product-form-artwork, .cp-product-form-artwork-by-email-checkbox', this.$container ).removeClass('has-error');            
             return true;
             
       }
    }

    const cpProductDiscountingRules = new function() {
        this.init = function() {
           this.$container = $('.cp-variant-wrapper-discounting-rules-component');
           if(this.$container.length != 1) {
             return;
           }

           if( 
              $('.js-discounting-rules[data-variant-selected="true"]',this.$container).length == 0 &&
              $('.js-discounting-rules[data-variant-first="true"]',this.$container).length == 1
             ){
              $('.js-discounting-rules[data-variant-first="true"]',this.$container).attr('data-variant-selected','true');
            }

           this.showCurrent();
           
           document.addEventListener('variant:change', (evt) => {

            const $variantRules = $('.js-discounting-rules[data-variant-id="' + evt.detail.variant.id + '"]', this.$container);
            if($variantRules.length > 0 ) {
              $variantRules
                .attr('data-variant-selected','true')
                .siblings()
                .attr('data-variant-selected','false');
            } else {
              $('.js-discounting-rules', this.$container)
                .attr('data-variant-selected','false');
            }
            this.showCurrent();
          });
        }

        this.showCurrent = function() {
            if( $('.js-discounting-rules[data-variant-selected="true"]',this.$container).length > 0 ){
              $('.js-discounting-rules[data-variant-selected="true"]:first', this.$container)
              .addClass('show').siblings().removeClass('show');
            } else {
              if($('.js-discounting-rules-product', this.$container).length == 1) {
                $('.js-discounting-rules-product', this.$container)
                .addClass('show').siblings().removeClass('show');
              } else {
                $('.js-discounting-rules').removeClass('show');
              }
            } 
        }
    }
    const cpProductForm = new function () {
        this.components = [];
        this.addComponent = function( component ) {
          this.components.push( component );
        }

        this.init = function () {
          const $productForm  = $('#AddToCartForm-' + $('.cp-product-section').data('section-id') );
          let isInitialized = false;
          for (const component of this.components ) {
             if( component.init() == true ){
                isInitialized = true;
             }
          }

          if( isInitialized == false) {
            return;
          }
          
          $productForm.on('submit', () => { 
            let isValidate = true;
            for (const component of this.components ) {
                 if (component.validate() == false ) {
                   isValidate = false;
                 }
            }

            return isValidate;
          });
        }
    }

    const cpProductPrice = new function () {
      this.init = function() {
        $(".cp-product-section").on('DOMSubtreeModified', ".product__price", () => {
          this.showPricePerEach();
          this.showTotalPrice();
        });

        $('.product__quantity .js-qty__num').on('change', () => {
           this.showTotalPrice();
        });
        $('.product__quantity button').on('click', () => {
           setTimeout( () => { 
             this.showTotalPrice();
           });
        });

        this.showPricePerEach();
        this.showTotalPrice();
      }

      this.getProductPrice = function () {
        const price_with_currency = $('.product__price:last').text().trim();
        if(/[0-9\.,]+/.test(price_with_currency) == false ) {
          return false;
        }

        const price_str = price_with_currency.match(/[0-9\.,]+/)[0]
        const price = parseFloat ( price_str.replace(',','') );
        
        return {
            price_with_currency,
            price_str,
            price
        }
      }

      this.showPricePerEach = function() {
        if($('#cp-js-product-price-each').length == 0 ) {  
          return;
        }

        const  product_price = this.getProductPrice();
       
        
        if( product_price === false) {
          return;
        }

        const pkg = parseInt($('#cp-js-product-price-each').data('pkg'));
        const price_each = (product_price.price/pkg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); 

        $('#cp-js-product-price-each')
          .text( product_price.price_with_currency.replace( product_price.price_str, price_each ))
          .addClass('show');
      
        $('#cp-js-product-price-each-label')
          .addClass('show');          

      }

      this.showTotalPrice = function() {

        const  product_price = this.getProductPrice();
        
        if( product_price === false) {
          return;
        }

        const quantity = parseInt($('.product__quantity .js-qty__num').val());
        if(isNaN(quantity)) {
          return;
        }

        if(quantity < 2 ) {
          $('#cp-js-product-total-price').removeClass('show');
          return;
        }

        const total_price = quantity * product_price.price;

        $('#cp-js-product-total-price span')
          .text( product_price.price_with_currency
            .replace( 
              product_price.price_str, 
              total_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
              ) );

          $('#cp-js-product-total-price').addClass('show');    


      }            

    }


    const cpProduct = new function( ) {

        this.components = [];

        this.addComponent = function( component ) {
          this.components.push( component );
        }
        this.init = function(){
          this.initScrollMoreBtn();
          this.initOrderForm();
          this.initOrderFormButton();

          for ( const component of this.components ) {
              component.init();
          }
        }
        
        this.initScrollMoreBtn = function() {
          $('.cp-js-scroll-more').on('click', function(){
            const selector = $(this).data('to');
            const scrollTop = $(selector).offset().top  - $('.site-header').height();
            try{
              $('html,body').animate({ scrollTop },400);
             } catch(e){}        
            });          
        }

        this.initOrderForm = function() {
          var scriptTag = document.createElement('script');
          scriptTag.src = 'https://custom-forms-client.acerill.com/js/custom-forms-v2.js';
          $('.cp-js-form-order-sample').after(scriptTag);          
        }
        
        this.initOrderFormButton = function() {
          $('.cp-form-order-sample').on('click','.cp-add-part-numbers',function(event){
      
            window.acerillCustomFormsEventBus.publish({ 
              eventType: 'UPDATE_VALUE_COMMAND', 
              fieldPredicate: { placeholder: 'Part numbers' }, 
              value: $('.product-single__sku').text() 
            });
    
          });          
        }
        this.fixShopperapproved = function(){
          $('script[src^="\/\/www.shopperapproved.com\/product\/29017\/"]').remove();
        } 
    }

    const cpProductAjaxLoading = new function( ) {
       this.init = function( cpProduct ) {
        const mainContentSelector = '#MainContent'; 
        $(mainContentSelector)
          .addClass('cp-product-loader')
          .on('click', '.cp-js-product-load', (e) => {
            var clicked = $( e.target );
          
          	if ( ! clicked.hasClass( 'color-swatch' ) ) {
              e.preventDefault();

              const url = e.target.href;
              this.loadContent(mainContentSelector,cpProduct, url );
        	}
          });

          $(mainContentSelector).on('change_cp_product_url', () => {
              const url = $(mainContentSelector).data('cp-product-url');
              this.loadContent(mainContentSelector,cpProduct, url );
          }); 

       } 

       this.loadContent = function(mainContentSelector,cpProduct, url ) {
          $(mainContentSelector).addClass('cp-product-loader-show');
          $.get(url,function(page){
            const  $page= $(page);

            if($('.cp-product-section', $page).length> 0){

              window.history.replaceState({path: url}, '', url);
              cpProduct.fixShopperapproved();
              
              $(mainContentSelector).html($(mainContentSelector, $page).html());
              theme.reinitProductGridItem();
              cpProduct.init();

            } else {
              window.open( url, '_self' );
            }

            $(mainContentSelector).removeClass('cp-product-loader-show');

          });
       }
    };
    
    if($('.cp-product-section').length > 0) {
      $(function(){
      const cpProductColor = new CpProductColor('#cp-js-product-custom-form  .cp-product-color-component');
      const cpProductBackgroundColor = new CpProductColor('#cp-js-product-custom-form  .cp-product-background-color-component');
      const cpProductBorderColor = new CpProductColor('#cp-js-product-custom-form  .cp-product-border-color-component');

      cpProduct.addComponent( cpProductPrice );
      cpProduct.addComponent( cpProductDiscountingRules );
      cpProduct.addComponent ( cpProductCalculator );

      // cpProductForm.addComponent(cpProductDimensionV1);
      cpProductForm.addComponent(cpProductDimension);
      
      cpProductForm.addComponent(cpProductColor);
      cpProductForm.addComponent(cpProductBackgroundColor);
      cpProductForm.addComponent(cpProductBorderColor);
      cpProductForm.addComponent( cpProductArtwork );
      cpProduct.addComponent( cpProductForm );

      cpProduct.init();
      //cpProductAjaxLoading.init(cpProduct);
      });
    }


    if ($('#cp-custom-poly-bags').length == 1) {
      $(function(){
         const $container = $('#cp-custom-poly-bags');
         let is_button_pressed = false;
         let custom_product = {
           category: "",
           product: "",
           mil: "",
           width: "",
           length: "",
           material: "",
           color: "",
         }
         function setValue( field, value ) {
          window.acerillCustomFormsEventBus.publish( 
            { eventType: 'UPDATE_VALUE_COMMAND', 
            fieldPredicate: 
            { placeholder:  field }, 
            value: value } 
            );
         }
         function validateField(elm) {
          const value = parseFloat($(elm).val());
          const min = parseFloat($(elm).attr('min'));
          const max = parseFloat($(elm).attr('max'));
          if(isNaN(value)) {
            return false;
          }

          if(isNaN(min) == false &  value < min ) {
            return false;
          }

          if(isNaN(max) == false &  value > max ) {
            return false;
          }

            return true;
         }

         $container.on('change.custom_product',function(){

            setValue('Product', custom_product.product + ' (' + custom_product.category + ')' );

            setValue('Mil', custom_product.mil );
            setValue('Width', custom_product.width );
            setValue('Length', custom_product.length );

            setValue('Material', custom_product.material );
            setValue('Color', custom_product.color );
            
         });

         $('.cp-js-custom-product',$container)
          .on('click',function(e){
              if(is_button_pressed) {
                return;
              }
              $(this).addClass('active').siblings().removeClass('active');

              const handle = $(this).data('custom-product-handle');
              custom_product.category = $(this).data('custom-product');
              $container.trigger('change.custom_product');

              $('.cp-js-custom-sizes-titles',$container).removeClass('show');
              $('.cp-js-custom-sizes-titles[data-custom-product-handle="'+ handle +'"]',$container).addClass('show');
              $('.cp-js-custom-sizes-titles[data-custom-product-handle="'+ handle +'"] .cp-js-custom-size-title:first', $container).trigger('click');
          });
        

          $('.cp-js-custom-size-title',$container)
          .on('click',function(){
            if(is_button_pressed) {
              return;
            }            
            $(this).addClass('active').siblings().removeClass('active');
            
            const handle = $(this).data('custom-size-title-handle');
            custom_product.product = $(this).data('custom-size-title');
            $container.trigger('change.custom_product');

            $('.cp-js-custom-sizes', $container).removeClass('show');
            $('.cp-js-custom-sizes[data-custom-size-title-handle="'+ handle +'"]', $container).addClass('show');

          }); 

          $('.cp-js-custom-sizes.show input', $container).on('keyup',function(){
            $(this).removeClass('has-error');
          });
          

          $('.cp-js-custom-material',$container)
          .on('click',function(){
            if(is_button_pressed) {
              return;
            }            
            $(this).addClass('active').siblings().removeClass('active');
            custom_product.material = $(this).data('custom-material');
            $container.trigger('change.custom_product');
          });  
          
          $('.cp-js-custom-color',$container)
          .on('click',function(){
            if(is_button_pressed) {
              return;
            }            
            $(this).addClass('active').siblings().removeClass('active');
            custom_product.color = $(this).data('custom-color');
            $container.trigger('change.custom_product');
          });   
          
          $('.cp-js-custom-button', $container).on('click', function(){
              let isValidForm = true;
              $('.cp-js-custom-sizes.show input', $container).removeClass('has-error');
              
              custom_product.mil = '';
              custom_product.width = '';
              custom_product.length = '';

              $('.cp-js-custom-sizes.show input', $container).each(function(idx){
                 const name = $(this).data('name');
                 const value = $(this).val();
                 const isValid = validateField(this);
                 custom_product[name] = value;
                 if(isValid == false ) {
                   isValidForm = false;
                   $(this).addClass('has-error');
                 } 

              });

              if(isValidForm) {
                $container.trigger('change.custom_product');
                is_button_pressed = true;
                $('.cp-js-custom-sizes.show input', $container).attr('readonly','readonly');  
                $(this).parent().hide();
                $('.cp-custom-poly-bags-form', $container).addClass('show');
              }

          });


          $('.cp-js-custom-product:first',$container).trigger('click');
          $('.cp-js-custom-material:first',$container).trigger('click');
          $('.cp-js-custom-color:first',$container).trigger('click');


      });
    }


   
